import { ReactNode } from 'react';
import { Dialog, DialogTitle, DialogContent, useTheme, Grid } from '@mui/material';
import CloseButton from "components/shared/CloseButton";

interface GeneralDialogProps {
	isOpen: boolean;
	onClose: () => void;
	content: ReactNode | string | null | undefined;
	title?: string | null | undefined;
	type?: 'success' | 'error' | 'warning' | 'info';
}

function GeneralDialog({ isOpen, content, title, onClose, type = 'info' }: GeneralDialogProps) {
	const theme = useTheme();

	// Define styles for different dialog types
	const dialogStyles = {
		success: {
			backgroundColor: theme.palette.success.main,
			color: theme.palette.getContrastText(theme.palette.success.main),
		},
		error: {
			backgroundColor: theme.palette.error.main,
			color: theme.palette.getContrastText(theme.palette.error.main),
		},
		warning: {
			backgroundColor: theme.palette.warning.main,
			color: theme.palette.getContrastText(theme.palette.warning.main),
		},
		info: {
			backgroundColor: theme.palette.info.main,
			color: theme.palette.getContrastText(theme.palette.info.main),
		},
	};

	// Apply styles based on the type prop
	const currentStyle = dialogStyles[type];

	return (
		<Dialog open={isOpen} onClose={onClose} maxWidth="xs">
			{ title && (
				<DialogTitle style={{ ...currentStyle }}>
					<Grid container justifyContent="space-between" alignItems="center" wrap="nowrap" spacing={2}>
						<Grid item>
							{title}
						</Grid>
						<Grid item>
							<CloseButton handleClose={onClose} />
						</Grid>
					</Grid>
				</DialogTitle>) }
			<DialogContent dividers>
				{content}
			</DialogContent>
		</Dialog>
	);
}

export default GeneralDialog;
